import { formatSliceOfEnum } from '@cbgms/base/utils/helpers'

interface Props {
  content: {
    type: string
    value: string[]
  }
}

export function SliceOfEnum({ content }: Props) {
  return <>{formatSliceOfEnum(content.type, content.value)}</>
}
